'use strict';
class DdjjdetalleobsModalController {
  constructor($uibModalInstance, data, $sce, $log, DataService, $state, $location) {
    'ngInject';
    this.items = data;
    this.$uibModalInstance = $uibModalInstance;
    this.$sce = $sce;
    this.$log = $log;
    this.DataService = DataService;
    this.$state = $state;
    this.$location = $location;
    // this.Loading = Loading;
  }

  $onInit() {
    // this.Loading.show('Cargando', true);
    this.tipo_formulario = this.items.tipo_formulario;
    this.estado_certificado = this.items.estado_certificado;
    this.selected = {
      item: this.items[0]
    };
  }

  ok() {
    var obj = {
      "observaciones_secciones": this.items.arrayObs,
      "observaciones": this.observacion
    };
    if (this.tipo_formulario === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || this.tipo_formulario === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO' && this.estado_certificado === 'APROBADO_ENVIADO') {
      obj.esProductoObservado = true;
    }
    this.DataService.put('certificaciones/' + this.items.id_certificacion + '/observar/', obj)
      .then(response => {
        if (response) {
          this.$location.path('declaracionesJuradas');
          this.$uibModalInstance.close(this.selected.item);
        }
      });

    this.$uibModalInstance.close(this.selected.item);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default DdjjdetalleobsModalController;



// WEBPACK FOOTER //
// ./src/app/components/admin/probolivia/ddjj/ddjjdetalle.modal.obs.controller.js